/**
 * RegulatoryCommitmentAdminPage (P429.2).
 *
 * Mount point for /foundation/admin/regulatory-commitments. Thin wrapper handing
 * the adapter to the shared AdminListView, as every other register does.
 */
import { AdminListView } from "./AdminListView";
import { regulatoryCommitmentAdapter } from "./regulatoryCommitmentAdapter";

export function RegulatoryCommitmentAdminPage() {
  return <AdminListView adapter={regulatoryCommitmentAdapter} />;
}
